// questo serve per creare le card per selligent o bantoa, in modo da non fare due volte il render
class CustomCarousel extends HTMLElement {
  static getUrl = `${Utils.SELLIGENT_API_URL}/api/shop/${Shopify.shop}/products-by-group-codes`;
  products; templates;

  constructor() {
    super();
    this.templates = this.querySelectorAll('[data-template]');
  }

  getProducts = (skus) => {
    axios({
      method: 'post',
      url: CustomCarousel.getUrl,
      params: {locale: Shopify.locale},
      headers: {
        'Content-Type': 'application/json',
      },
      data: skus
    }).then((response) => {
      const prods = response.data.products.map((product) => {
        return this.getTrackingProduct(product);
      });
      this.products = {products: prods, relatedProducts: response.data.relatedProducts};
      this.render();
    }).catch((error) => {
      console.error(error);
    });
  }

  getTrackingProduct = (product) => {
    // estendere per tornare il prodotto con il tracking url (tracking_url)
    return product;
  }

  render = () => {
    const template = this.getTemplate('carousel')?.innerHTML;
    if(!template) {
      console.error('CustomCarousel: No template found for carousel');
      return;
    }
    if(this.products.products.length === 0) {
      this.innerHTML = '';
      return;
    }

    this.innerHTML = template;
    const wrapper = this.querySelector('[data-products]');
    if(!wrapper) {
      console.error('CustomCarousel: No wrapper found for products');
      return;
    }

    const renderingProducts = this.products.products.slice(0, 10);

    Promise.all(renderingProducts.map((product) => {
      return axios.get(`${Shopify.routes.root}products/${product.handle}/?section_id=helper-card`);
    })).then((htmls) => {
      wrapper.innerHTML = htmls.map((response, i) => {
        const html = response.data.replaceAll(`${Shopify.routes.root}products/${renderingProducts[i].handle}`, renderingProducts[i].trackingUrl || `${Shopify.routes.root}products/${renderingProducts[i].handle}`);
        return html;
      }).join('');
    }).catch((error) => {
      console.error('CustomCarousel: Error rendering products', error);
      this.innerHTML = '';
    });
    
    this.classList.add('loaded');

  };

  getTemplate = (name) => { 
    const t = Array.from(this.templates).filter((template) => template.dataset.template === name);
    return t.length > 0 ? t[0] : null;
  }
}